export default __webpack_public_path__ + "images/1L.bf50cc9.png";